import api, { API_URL } from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/reunion");
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/reunion/${id}`);
  return response.data;
};

export const getByEmpresa = async (id) => {
  const response = await api.get(`/reunion/porEmpresa/${id}`);
  return response.data;
};

export const create = async (idEmpresa1, idEmpresa2) => {
  const params = {};
  params.idEmpresa1 = idEmpresa1 ?? null;
  params.idEmpresa2 = idEmpresa2 ?? null;
  const response = await api.post(
    "/reunion/createReunion",
    { params },
    { timeout: 30000 }
  );
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/reunion/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/reunion/${id}`, { timeout: 30000 });
};

export const generarAgendaPDF = (idEmpresa) => {
  window.open(
    `${API_URL}/api/pdf/agenda/${idEmpresa}`,
    "_blank",
    { timeout: 30000 }
  );
};
